import React from "react";
import App from "apps/messenger/containers/App";

const Messenger = () => (
	<App />
);

export default Messenger;



// WEBPACK FOOTER //
// ./src/apps/messenger/index.js